"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var CardRowNumericEditor_1 = require("../../../../../../../../shared/components/editors/CardRowNumericEditor");
var CardRowTextEditor_1 = require("../../../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var PlayerJackPotWinAction = /** @class */ (function (_super) {
    __extends(PlayerJackPotWinAction, _super);
    function PlayerJackPotWinAction(props) {
        return _super.call(this, props) || this;
    }
    PlayerJackPotWinAction.prototype.componentWillMount = function () {
        var _this = this;
        this.setState({
            jackpot_id: 0,
            jackpot_title: "",
            jackpot_amount: 0,
            description: "",
            is_notify_all: false,
            avail_jackpots: []
        });
        this.SID_AJ = this.props.dataJpAvail.Subscribe("*", function (id, data) {
            _this.setState({ avail_jackpots: data.data });
        });
        this.props.dataJpAvail.LoadData(this.props.rootRecord.key);
        this.doReSetRules();
    };
    PlayerJackPotWinAction.prototype.componentWillUnmount = function () {
        this.props.dataJpAvail.UnSubscribe(this.SID_AJ);
    };
    PlayerJackPotWinAction.prototype.doReSetRules = function () {
        this.setState({
            jackpot_rules: { isError: false },
            jackpot_amount_rules: { isError: false }
        });
    };
    PlayerJackPotWinAction.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.jackpot_title) || (this.state.jackpot_title.length === 0)) {
            this.setState({ jackpot_rules: { isError: true, errorMessage: "Поле [джекпот] не выбрано!" } });
            return false;
        }
        if ((this.state.jackpot_amount <= 0) || (this.state.jackpot_amount > 9999999)) {
            this.setState({
                jackpot_amount_rules: {
                    isError: true,
                    errorMessage: "Поле [сумма выигрыша джекпота] имеет недопустимое значение"
                }
            });
            return false;
        }
        return true;
    };
    PlayerJackPotWinAction.prototype.MakeJackpotWinClick = function () {
        if (this.isDataValid()) {
            this.props.dataJpWins.CreateJackpotWin({
                bonusJackpotId: this.state.jackpot_id,
                jpAmountInPlayerCurrency: this.state.jackpot_amount,
                usrPlayerId: this.props.rootRecord.key,
                description: this.state.description,
                isNotifyAll: this.state.is_notify_all
            }, function () {
                notificationHelper_1.default.ShowTopRightNotificationText("Выигрыш джекпота был успешно создан!");
            });
        }
    };
    PlayerJackPotWinAction.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PlayerJackPotWinAction.prototype.getFormTitle = function () {
        return "Выплата джекпота";
    };
    PlayerJackPotWinAction.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 400 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Выберите джекпот:", placeholder: "Выберите джекпот" }, value: { key: this.state.jackpot_id, value: this.state.jackpot_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        jackpot_id: newVal.key,
                        jackpot_title: newVal.value,
                        jackpot_rules: { isError: false }
                    });
                }, items: this.state.avail_jackpots, required: true, rules: this.state.jackpot_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "\u0421\u0443\u043C\u043C\u0430 \u0432\u044B\u0438\u0433\u0440\u044B\u0448\u0430," + this.props.rootRecord.app_currency_title + ":",
                    placeholder: "\u0421\u0443\u043C\u043C\u0430 \u0432\u044B\u0438\u0433\u0440\u044B\u0448\u0430 \u0432 \u0432\u0430\u043B\u044E\u0442\u0435 \u0438\u0433\u0440\u043E\u043A\u0430, " + this.props.rootRecord.app_currency_title
                }, values: { min: 1, max: 999999999, value: this.state.jackpot_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        jackpot_amount: newVal,
                        jackpot_amount_rules: { isError: false }
                    });
                }, required: true, rules: this.state.jackpot_amount_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Уведомить всех игроков о выигрыше", value: this.state.is_notify_all, onChecked: function (checked) { _this.setState({ is_notify_all: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: false, title: { btnNew: "Выплатить", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.MakeJackpotWinClick.bind(this) })));
    };
    return PlayerJackPotWinAction;
}(React.Component));
exports.default = PlayerJackPotWinAction;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ui/component/operations/jackpot/PlayerJackpotWinAction.tsx
// module id = 1938
// module chunks = 0